import { createContext } from 'react';

const herramientaContext = createContext();

export default herramientaContext;
